import { OrderedDataFieldValue } from "../../dataFields/values/OrderedDataFieldValue";
import { VersionState } from "../../enumerations/VersionState";
import { OrderedEntryGroup } from "../entryGroups/OrderedEntryGroup";
import { OrderedListingGroup } from "../listingGroups/OrderedListingGroup";
import { OrderedSection } from "./OrderedSection";

export class SectionVersion {
	public static readonly $type: string = "SectionVersion";
	public readonly $type: string = SectionVersion.$type;

	public id?: number;
	public name: string = "";
	public metadata: OrderedDataFieldValue[] = [];
	public entryGroups: OrderedEntryGroup[] = [];
	public listingGroups: OrderedListingGroup[] = [];
	public sections: OrderedSection[] = [];
	public state: VersionState = VersionState.Draft;

	constructor(name: string) {

		this.name = name;
	}
}
